export type IProductPriceDataPoint = {
    Change: number,
    Date: string,
    NormalisedValue: number,
    TimeStamp: number,
    Value: number,
}

// portfolio API data to Victory pie data
export const mapPortfolioPerformance = (data: any) => {
    return [
        {
            x: 0,
            y: 10,
        }, {
            x: 0,
            y: 20,
        }, {
            x: 0,
            y: 30,
        }
    ]
}

// portfolio API data to Victory pie data
export const mapProductPrice = (data: any) => {
    const mappedData = data?.map((dataPoint: IProductPriceDataPoint) => ({
        // x: format(new Date(dataPoint?.Date), 'dd MMM yyyy, HH:mm'),
        x: new Date(dataPoint?.Date),
        y: dataPoint.Value
    }))

    // if (mappedData?.length > 0) {
    //     console.log('GraphData', { data, mappedData })
    // }

    return mappedData;
}